import { ColumnFieldTitle, FieldSet, FormErrorServicesService, checkLinkFormData, checkNestedProperty } from "@urbannex/ofbiz-forms";

export function getFields(formName:string,FORMS):any[]{
    const errorSevices = new FormErrorServicesService();
    let fields:any[];
    let columnFieldTitles:ColumnFieldTitle[];
    let localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    if(localForm){
        fields = localForm.fields;
        errorSevices.checkFormFieldErrors(fields,localForm.formName);
        columnFieldTitles = columnFieldTitles = localForm.columns;
        if(columnFieldTitles != undefined && columnFieldTitles.length > 0){
            //console.log("Found columnFieldTitles");
            
            fields.forEach(field => {
                let columnField = columnFieldTitles.find(element => element.name == field.name);
                if(columnField){
                    //console.log({FoundColumnField:{field:field.name,columnFieldTitle:columnField}})
                    field.title = columnField.title;
                }
                /* if(field.hyperlink){
                    console.log(field)
                    try{
                        if(localForm.formName == "UpdateProductCategoryMember"){
                            checkNestedProperty(field.hyperlink,"remoteFormData")
                            checkLinkFormData(field,"event")
                        }
                    }catch(error){
                        console.log(error, localForm.formName)
                    }
                    
                } */
            })
            
        }
    }
    console.log("The Fields for: "+formName,fields);
    return fields;
}

export function getColumnFieldTitles(formName:string,FORMS:any[]):ColumnFieldTitle[]{
    let columnFieldTitles:any[];
    let localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    if(localForm && localForm.columns){
        columnFieldTitles = localForm.columns;
    }
    console.log({columnFieldTitles:columnFieldTitles,"formName":formName});
    return columnFieldTitles
}

export function getTitleDescriptionField(formName:string,FORMS):string{
    let localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    let fieldName = localForm.titleDescriptionField ? localForm.titleDescriptionField : "";
    console.log(fieldName)
    return fieldName;
}

export function getIdFieldName(formName:string,FORMS):string{
    let localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    let fieldName = localForm.idFieldName ? localForm.idFieldName : "";
    return fieldName;
}

export function getFieldSets(formName:string,FORMS):FieldSet[]{
    let fieldSets = [];
    let localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    fieldSets = localForm.fieldSets;
    return fieldSets;
}

export function getTarget(formName:string,FORMS):string{
    let target = "";
    let localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    target = localForm.target;
    return target;
}

export function getAppContext(formName:string,FORMS):string{
    let form = FORMS.find(form => form.name == formName || form.formName == formName);
    let appContext = form.appContext || "";
    return appContext
}
export function getAltTarget(formName:string,FORMS):any[]{
    let altTargets = [];
    let localForm = FORMS.find(form => form.name == formName || form.formName == formName);
    altTargets = localForm.altTarget;
    return altTargets;
}
/**
 * 
 * @param formName 
 * @param FORMS 
 * @returns targets object consisting of createTarget and EditTarget
 */
export function getTargets(formName:string,FORMS):any{
    let targets = {}
    let form = FORMS.find(form => form.name == formName || form.formName == formName);
    targets = form.targets;
    return targets
}